// extracted by mini-css-extract-plugin
export default {"citation-list-container":"styles_citation-list-container__7KGAs","citation-list-title":"styles_citation-list-title__mpsn0"};